import { render, staticRenderFns } from "./UiAvatar.vue?vue&type=template&id=ba6bcdc4&scoped=true&"
import script from "./UiAvatar.vue?vue&type=script&lang=js&"
export * from "./UiAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UiAvatar.vue?vue&type=style&index=0&id=ba6bcdc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6bcdc4",
  null
  
)

export default component.exports